exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-lg[data-v-99e48590] {\r\n  width: 100%;\r\n  height: calc(322px * (9 / 16));\r\n  overflow: hidden;\n}\r\n", ""]);

// exports
